// extracted by mini-css-extract-plugin
export default {"wrapper":"_23GMg","header":"_3VzC8","divider":"_2Tdc7","mobileCheckoutWrapper":"OZP5u","mobileCheckoutHeader":"_1_-1o","mobileCheckoutDivider":"vp2WB"};